import { useState } from "react";
import { MailWarning, X } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function VerifyBanner() {
  const { user, resendVerification } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);

  if (!user || typeof user !== "object" || user.email_verified || dismissed) return null;

  const resend = async () => {
    setSending(true);
    try {
      const data = await resendVerification();
      toast.success(data.message || "Verification email sent.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not send email.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      data-testid="verify-email-banner"
      className="flex flex-wrap items-center gap-3 border-b border-brand-orange/30 bg-brand-orange/10 px-4 py-3 text-sm sm:px-6"
    >
      <MailWarning className="h-4 w-4 shrink-0 text-brand-orange" />
      <p className="text-foreground">
        Verify your email <span className="font-medium">{user.email}</span> to secure your account.
      </p>
      <button
        onClick={resend}
        disabled={sending}
        data-testid="resend-verification-btn"
        className="rounded-full bg-foreground px-3 py-1.5 text-xs font-semibold text-background transition-opacity hover:opacity-90 disabled:opacity-60"
      >
        {sending ? "Sending…" : "Resend email"}
      </button>
      <button onClick={() => setDismissed(true)} aria-label="Dismiss" className="ml-auto text-muted-foreground hover:text-foreground">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
